//import * as XLSX from "xlsx";

import { saveAs } from "file-saver";

/**
 * @description Mapea los datos de los productos a un formato de objeto plano
 * adecuado para la exportación a Excel.
 * @param dataT Array de datos de productos.
 * @returns Array de objetos listos para la hoja de cálculo.
 */
export const mapReporteContratosToExcel = (dataT: any[]) => {
    return dataT.map(item => ({
        "CONTRATO SOFTNET": item.idContrato,
        "CONTRATO EVA": item.contratoEva,
        "FECHA INSTALACION": item.fechaInstalacion,
        "FECHA SUBIDA": item.fechaSubida,
        "IDENTIFICACION": item.identificacion,
        "NOMBRE CLIENTE": item.nombreCliente,
        "NOMBRE CIUDAD": item.nombreCiudad,
        "NOMBRE PLAN": item.nombrePlan,
        "AREA VENTAS": item.areaVentas,
        "NOMBRE VENDEDOR": item.nombreVendedor,
        "DETALLE PAGO": item.detallePago,
        "NOMBRE TECNICO": item.nombreTecnico,
        "OBSERVACION TECNICO": item.observacionTecnico,
        "OBSERVACION VENTAS": item.observacionVentas,
        "FECHA ULTIMA ACTUALIZACION": item.fechaUltimaActualizacion,
        "ESTADO CONTRATO EVA": item.estadoContratoEva,
        "ESTADO CONTRATO SOFTNET": item.estadoContratoSoftnet,
        "ESTADO SERVICIO SOFTNET": item.estadoServicioSoftnet,
        "TIPO CONTRATO": item.tipoContrato,
        "FORMA DE PAGO": item.formaPago,
        "BANCO": item.banco,
        "TIPO DESCUENTO": item.tipoDescuento,
        "DOCUMENTOS CARGADOS": item.documentosCargados,
        "EXISTE MIGRACION": item.existeMigracion,
        "REVISION MIGRACION": item.revisionMigracion
    }));
};

/**
 * @description Exporta los datos mapeados a un archivo Excel (.xlsx).
 * Aplica estilos de negrita al título principal y a los encabezados de las columnas.
 * @param dataT Array de datos ya mapeados (del formato de mapProductosToExcel).
 * @param nameFile Nombre del archivo de salida.
 */
export const exportExcel = (dataT: any[], nameFile = "producto") => {

    // 1) Crear hoja con headers y datos
    const hoja = XLSX.utils.json_to_sheet(dataT);

    // 2) Guardar el rango original (rango de los datos y encabezados)
    const range = XLSX.utils.decode_range(hoja["!ref"]!);

    // 3) MOVER TODOS LOS DATOS UNA FILA ABAJO (para hacer espacio al título en A1)
    // El bucle comienza desde la última fila y va hacia arriba.
    for (let R = range.e.r; R >= 0; R--) {
        for (let C = 0; C <= range.e.c; C++) {
            const oldCellAddress = XLSX.utils.encode_cell({ r: R, c: C });
            const newCellAddress = XLSX.utils.encode_cell({ r: R + 1, c: C });

            // Mueve el contenido y el estilo
            hoja[newCellAddress] = hoja[oldCellAddress];
            // Elimina la celda original (opcional, pero limpio)
            delete hoja[oldCellAddress];
        }
    }

    // 4) AJUSTAR RANGO DE LA HOJA
    // Ahora el rango va desde la fila 0 hasta la fila original + 1
    hoja["!ref"] = XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: range.e.r + 1, c: range.e.c }
    });

    // 4.5) AJUSTAR ANCHO DE COLUMNAS (Para que sean "poco grandes")
    // El ancho de columna se define en unidades de 'Width in Characters' (wch).
    const numCols = range.e.c + 1;
    hoja["!cols"] = [];

    for (let C = 0; C < numCols; C++) {
        // Establece un ancho fijo de 20 caracteres para todas las columnas
        hoja["!cols"].push({ wch: 20 });
    }

    // --- APLICACIÓN DE ESTILOS ---

    // 5) ESCRIBIR EL TÍTULO EN A1 CON NEGRITA Y TAMAÑO GRANDE
    const titulo = "REPORTE CONTRATOS";
    hoja["A1"] = {
        t: "s",
        v: titulo,
        s: {
            font: {
                bold: true,
                sz: 18, // Tamaño de fuente grande para el título
                color: { rgb: "000000" }
            },
            alignment: {
                horizontal: "center",
                vertical: "center"
            }
        }
    };

    // 6) FUSIONAR CELDAS PARA EL TÍTULO
    hoja["!merges"] = [
        {
            s: { r: 0, c: 0 },
            e: { r: 0, c: range.e.c } // Fusión desde A1 hasta la última columna de la hoja
        }
    ];

    // 7) APLICAR NEGRITA A LOS ENCABEZADOS DE COLUMNA (Ahora están en la fila de índice 1)
    const headerStyle = {
        font: {
            bold: true,
            color: { rgb: "000000" },
        },
        // Opcional: Centrar encabezados
        alignment: {
            horizontal: "center",
            vertical: "center"
        }
    };

    // Iterar sobre las celdas de la fila 1 (los encabezados)
    for (let C = 0; C <= range.e.c; C++) {
        const cellAddress = XLSX.utils.encode_cell({ r: 1, c: C });

        // La celda existe y es de tipo string ('s')
        if (hoja[cellAddress] && hoja[cellAddress].t === 's') {
            // Aplicar el estilo de negrita al encabezado. Preservar si ya tiene un objeto de estilo, si no, crear uno nuevo.
            hoja[cellAddress].s = { ...hoja[cellAddress].s, ...headerStyle };
        }
    }

    // 8) EXPORTAR
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hoja, "Datos");

    // ¡IMPORTANTE! Se agregó cellStyles: true para que la librería incluya la información de estilos personalizados (.s)
    // y ahora también el ancho de columna.
    const excelBuffer = XLSX.write(libro, { bookType: "xlsx", type: "array", cellStyles: true });

    const archivo = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(archivo, nameFile + ".xlsx");
};